export const reportSalesCustomerTypes = {
  GET_REPORT_SALES_CUSTOMER: 'GET_REPORT_SALES_CUSTOMER',
  SET_REPORT_SALES_CUSTOMER_FILTERS: 'SET_REPORT_SALES_CUSTOMER_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};